import VueRouter from 'vue-router';
import Hopbomb from './pages/Hopbomb';
import Funkwerks from './pages/Funkwerks';
import BronxBrewery from './pages/Bronxbrewery';
import Cider from './pages/Cider';
import Alesong from './pages/Alesong';
import Degarde from './pages/Degarde';
import KUIUAnchorage from './pages/KUIUAnchorage';
import SpecialSauce from './pages/SpecialSauce';
import SapwoodCellars from './pages/SapwoodCellars';
import PfriemstersArtisanClub from './pages/PfriemstersArtisanClub';
import PfriemstersCellarClub from './pages/PfriemstersCellarClub';
import AleApothecary from './pages/AleApothecary';
import FairIsleKnittingCircle from './pages/FairIsleKnittingCircle';
import PureProjectCellarC from './pages/PureProjectCellarC';
import PerennialSociete from './pages/PerennialSociete';
import HorusSkyGod from './pages/HorusSkyGod';
import HorusCrownedEagle from './pages/HorusCrownedEagle';
import SideProjectFarmClub from './pages/SideProjectFarmClub';
import CelladorAlesSyndicate from './pages/CelladorAlesSyndicate';
import CycleBenefactorsClub from './pages/CycleBenefactorsClub';
import OAuthCallback from './pages/OAuthCallback';

// import Index from './pages/Index';
// { path: '/', component: Index },
const routes = [
  { path: '/degarde', component: Degarde },
  { path: '/alesong', component: Alesong },
  { path: '/hopbomb', component: Hopbomb },
  { path: '/funkwerks', component: Funkwerks },
  { path: '/bronxbrewery', component: BronxBrewery },
  { path: '/cider', component: Cider },
  { path: '/kuiuanchorage', component: KUIUAnchorage },
  { path: '/specialsauce', component: SpecialSauce },
  { path: '/sapwoodCellars', component: SapwoodCellars },
  { path: '/pfriemstersCellarClub', component: PfriemstersCellarClub },
  { path: '/pfriemstersArtisanClub', component: PfriemstersArtisanClub },
  { path: '/aleApothecary', component: AleApothecary },
  { path: '/fairIsleKnittingCircle', component: FairIsleKnittingCircle },
  { path: '/pureProjectCellarC', component: PureProjectCellarC },
  { path: '/PerennialSociete', component: PerennialSociete },
  { path: '/HorusSkyGod', component: HorusSkyGod },
  { path: '/HorusCrownedEagle', component: HorusCrownedEagle },
  { path: '/SideProjectFarmClub', component: SideProjectFarmClub },
  { path: '/celladorAlesSyndicate', component: CelladorAlesSyndicate },
  { path: '/cycleBenefactorsClub', component: CycleBenefactorsClub },
  { path: '/oauth/callback', component: OAuthCallback },
];


const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;




// WEBPACK FOOTER //
// ./src/router.js